const CookiesHelper = {
    setItem: (key, value, expiry = 0) => {
        let expires = expiry.toString();
        if (expiry) {
            const expiredTime = new Date;
            expiredTime.setTime(expiredTime.getTime() + (expiry * 24 * 60 * 60 * 1000));
            expires = expiredTime.toUTCString();
        }
        document.cookie = key + '=' + encodeURI(value) + ';expires=' + expires + ';path=/';
    },
    getItem: (key) => {
        let keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? decodeURI(keyValue[2]) : null;
    },
    removeItem: (key) => {
        let keyValue = CookiesHelper.getItem(key);
        CookiesHelper.setItem(key, keyValue, '-1');
    }
}
